<template>
  <div class="c-main">
    <h2 class="c-title c-title--page">{{$t('organisation.passwords')}}</h2>
    <div class="c-main--flex-1">
      <div class="o-layout">
        <div class="o-layout__item">
          <div class="c-input--extra-info">
            <span v-html="$t('organisation.passwords.description')"></span>
          </div>
        </div>
        <div class="o-layout__item">
          <eventPasswords  type="organisations" :typeId="$route.params.organisationId" />
        </div>
      </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'OrganisationPasswords',
  components: {
    eventPasswords: () => import('@/components/eventPasswords.vue')
  },
}
</script>
